import api from './api';
import { Presupuesto, PresupuestoAnual } from '../types';

class PresupuestoService {
  async getPresupuestos(anio?: number, rubroId?: number, tipo?: 'ingreso' | 'gasto'): Promise<Presupuesto[]> {
    const params = new URLSearchParams();
    if (anio) params.append('anio', anio.toString());
    if (rubroId) params.append('rubroId', rubroId.toString());
    if (tipo) params.append('tipo', tipo);

    const response = await api.get(`/presupuesto?${params.toString()}`);
    return response.data;
  }

  async getPresupuestoPorAnio(anio: number): Promise<PresupuestoAnual[]> {
    const response = await api.get(`/presupuesto/anio/${anio}`);
    return response.data;
  }

  async getPresupuestoById(id: number): Promise<Presupuesto> {
    const response = await api.get(`/presupuesto/${id}`);
    return response.data;
  }

  async createPresupuesto(data: {
    rubroId: number;
    anio: number;
    mes: number;
    montoPresupuestado: number;
    observaciones?: string;
  }): Promise<Presupuesto> {
    const response = await api.post('/presupuesto', data);
    return response.data;
  }

  async updatePresupuesto(id: number, data: {
    montoPresupuestado?: number;
    observaciones?: string;
  }): Promise<Presupuesto> {
    const response = await api.patch(`/presupuesto/${id}`, data);
    return response.data;
  }

  async deletePresupuesto(id: number): Promise<void> {
    await api.delete(`/presupuesto/${id}`);
  }

  async guardarPresupuestoAnual(
    rubroId: number,
    anio: number,
    meses: { mes: number; monto: number; presupuestoId?: number }[]
  ): Promise<void> {
    // Guardar o actualizar cada mes
    for (const mesData of meses) {
      if (mesData.presupuestoId) {
        // Actualizar existente
        await this.updatePresupuesto(mesData.presupuestoId, {
          montoPresupuestado: mesData.monto
        });
      } else if (mesData.monto > 0) {
        // Crear nuevo solo si el monto es mayor a 0
        await this.createPresupuesto({
          rubroId,
          anio,
          mes: mesData.mes,
          montoPresupuestado: mesData.monto
        });
      }
    }
  }
}

const presupuestoService = new PresupuestoService();
export default presupuestoService;
